/*
 * Copyright (c) 2019. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import classNames from "classnames";
import * as React from "react";
import LoadingBarIcon from "../Icons/LoadingBarIcon";
import styles from "./Loading.module.scss";

export interface Props {
  children?: React.ReactNode;
  className?: string;
}

const Loading = (props: Props) => (
  <div className={classNames(styles.loading, props.className)}>
    <div className={styles.container}>
      <LoadingBarIcon />
      {props.children && (
        <div className={classNames(styles.children, "container flex items-center justify-center")}>
          {props.children}
        </div>
      )}
    </div>
  </div>
);

export default Loading;
